var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.erros.length > 0)?_c('app-erros-box',{attrs:{"erros":_vm.erros}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }